import CreditMeter from "./credit_meter"
import UpgradeCreditsButton from "./upgrade_credits_button"
import { spentPercentage } from "./utils/credits"
import { CreditsBalance, formatCredits } from "shared/utils/credits"

import styles from "./credit_balance_bar.module.scss"

interface Props {
  balance: CreditsBalance
  onUpgrade: () => void
}

const CreditBalanceBar = ({ balance, onUpgrade }: Props) => (
  <div className={styles["credit-balance-bar"]}>
    <CreditMeter filled={spentPercentage(balance)}>
      <span className="body-caption">
        {formatCredits(balance.remaining)} of {formatCredits(balance.total)} credits are left.
      </span>
    </CreditMeter>
    <UpgradeCreditsButton onClick={onUpgrade} />
  </div>
)

export default CreditBalanceBar
